import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a28bb2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["accept", "multiple", "disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["is-over"]
const _hoisted_4 = { class: "flex flex-col justify-center items-center px-6 py-10 w-full" }
const _hoisted_5 = { class: "text-sm font-medium text-gray-600 mb-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "text-primary-color-600" }, "Upload a file", -1))
const _hoisted_7 = { class: "text-xs text-gray-500" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "px-6 py-10 flex items-center justify-center flex-wrap gap-8 text-sm" }
const _hoisted_10 = ["onMouseover", "onMouseleave"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-10 h-10",
  src: "/img/pdf-preview.svg",
  alt: "pdf"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["height", "width", "src"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onMouseover", "onMouseleave"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-10 h-10",
  src: "/img/pdf-preview.svg",
  alt: "pdf"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "flex flex-col gap-y-2 px-7 py-3 max-h-32 overflow-y-auto" }
const _hoisted_22 = { class: "flex flex-row items-center w-full justify-between mb-3 last:mb-0" }
const _hoisted_23 = { class: "flex flex-row" }
const _hoisted_24 = { class: "image-text" }
const _hoisted_25 = { class: "flex flex-row items-center w-full justify-between mb-3 last:mb-0" }
const _hoisted_26 = { class: "flex flex-row" }
const _hoisted_27 = { class: "image-text" }
const _hoisted_28 = { key: 1 }

import { onMounted, PropType, ref, computed, Component } from "vue"
import { UserGroupIcon, PaperClipIcon, TrashIcon } from "@heroicons/vue/outline"
import { ToastService } from "@/shared/services/toast"
import { UploadFile } from "@/shared/models/upload-file"


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsFileUpload',
  props: {
    modelValue: {
        type: Array as PropType<File[]>,
        default: () => [],
    },
    multipleFiles: {
        type: Boolean,
        default: false,
    },
    accept: {
        type: Array as PropType<string[]>,
        default: Array.from(["image"]),
        validator: (values: string[]) =>
            values.every((value) => ["image", "video", "audio", "doc", "pdf", "excel", "text"].includes(value)),
    },
    maxSize: {
        type: Number,
        default: 1,
    },
    defaultDocuments: {
        type: Array as PropType<UploadFile[]>,
        default: () => [],
    },
    isPreview: {
        type: Boolean,
        default: false,
    },
    isDisabled: {
        type: Boolean,
        default: false,
    },
    minWidth: {
        type: String,
        default: "200",
    },
    minHeight: {
        type: String,
        default: "200",
    },
    fileUrl: {
        type: String,
        default: "",
    },
    isButtonUpload: {
        type: Boolean,
        default: false,
    },
    dragAndDropText: {
        type: String,
        default: "",
    },
    acceptFilesText: {
        type: String,
        default: "",
    },
    mainIcon: {
        type: Object as PropType<Component>,
        default: UserGroupIcon,
    },
},
  emits: ["update:modelValue", "uploadFiles", "removeFile", "removePreviewFile"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
const toastService = new ToastService()

const fileList = computed<File[]>({
    get() {
        return props.modelValue
    },
    set(val) {
        emit("update:modelValue", val)
    },
})
const uploadedFileList = computed(() => props.defaultDocuments)
const hiddenInput = ref<HTMLInputElement>()
const dragAndDrop = ref<HTMLElement>()
const acceptedTypes = ref("")
const errorMsg = ref("")
const hoveredFileName = ref("")
const isOver = ref(false)
const isXVisible = ref(false)
const isOverClass = computed(() => (isOver.value ? "bg-gray-100" : "bg-white"))
const disabledClass = computed(() => (props.isDisabled ? "opacity-50 pointer-events-none" : ""))

// This needed when the user reselects the same file
function fixReselect() {
    if (hiddenInput.value) {
        hiddenInput.value.value = ""
    }
}

function inputClick() {
    hiddenInput.value?.click()
}

function hoverOnFile(fileName: string) {
    return isXVisible.value && hoveredFileName.value === fileName ? "opacity-50" : ""
}

function toggleDragOver() {
    isOver.value = true
}

function toggleDragLeave() {
    isOver.value = false
}

function onChange(files: FileList | undefined, isDrop = false) {
    if (!files?.length) {
        return
    }
    if (props.multipleFiles) {
        Array.from(files).forEach((file) => {
            validateFile(file)
        })
    } else {
        if (files.length > 1) errorMsg.value = "You can only upload one file"
        validateFile(files[0])
        fileList.value = [files[0]]
    }

    if (isDrop) {
        isOver.value = false
    }

    if (errorMsg.value.length) {
        toastService.addToast({ message: errorMsg.value, type: "error" })
        errorMsg.value = ""
    }
    emit("uploadFiles", fileList.value)
}

function validateFile(file: File) {
    if (!validateType(file)) {
        errorMsg.value = "The file type is not allowed"
    } else if (
        fileList.value.some(({ name }) => name === file.name) ||
        uploadedFileList.value.some(({ name }) => name === file.name)
    ) {
        errorMsg.value = "The file already exists"
    } else {
        fileList.value.push(file)
    }

    if (errorMsg.value.length) {
        toastService.addToast({ message: errorMsg.value, type: "error" })
        errorMsg.value = ""
    }
}

function validateType(file: File): boolean {
    return acceptedTypes.value.includes(file.type)
}

function createPreview(file: File) {
    return URL.createObjectURL(file)
}

function setXButton(name: string, visibility: boolean) {
    hoveredFileName.value = name
    isXVisible.value = visibility
}

function removeItemFromList(index: number) {
    fileList.value.splice(index, 1)
    emit("uploadFiles", fileList.value)
}

function removePreviewFile(index: number, name: string, isExisting: boolean) {
    isExisting ? uploadedFileList.value.splice(index, 1) : fileList.value.splice(index, 1)
    emit("removePreviewFile", name)
}

function setAcceptTypes() {
    props.accept.forEach((type) => {
        switch (type) {
            case "image": {
                acceptedTypes.value = `${acceptedTypes.value},image/jpeg,image/png,image/gif`
                break
            }
            case "video": {
                acceptedTypes.value = `${acceptedTypes.value},video/mp4,video/3gpp,video/webm,video/quicktime`
                break
            }
            case "audio": {
                acceptedTypes.value = `${acceptedTypes.value},audio/mp3,audio/3gpp,audio/mpeg,audio/wave`
                break
            }
            case "doc": {
                acceptedTypes.value = `${acceptedTypes.value},.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document`
                break
            }
            case "pdf": {
                acceptedTypes.value = `${acceptedTypes.value},application/pdf`
                break
            }
            case "excel": {
                acceptedTypes.value = `${acceptedTypes.value},text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`
                break
            }
            case "text": {
                acceptedTypes.value = `${acceptedTypes.value},text/plain`
                break
            }
        }
    })
    acceptedTypes.value = acceptedTypes.value.replace(",", "")
}

onMounted(() => {
    setAcceptTypes()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col w-fit", disabledClass.value])
  }, [
    _createElementVNode("input", {
      ref_key: "hiddenInput",
      ref: hiddenInput,
      type: "file",
      hidden: "",
      accept: acceptedTypes.value,
      multiple: __props.multipleFiles,
      disabled: __props.isDisabled,
      onClick: fixReselect,
      onChange: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onChange($event?.target?.files)), ["prevent","stop"]))
    }, null, 40, _hoisted_1),
    (!__props.isButtonUpload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "dragAndDrop",
            ref: dragAndDrop,
            class: _normalizeClass(["border-2 rounded-md border-dashed w-full", isOverClass.value]),
            "is-over": isOver.value,
            onDragover: _withModifiers(toggleDragOver, ["prevent","stop"]),
            onDragleave: _withModifiers(toggleDragLeave, ["prevent","stop"]),
            onDrop: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onChange($event?.dataTransfer?.files, true)), ["prevent","stop"]))
          }, [
            _createElementVNode("div", {
              class: "w-full cursor-pointer",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (hiddenInput.value?.click()), ["prevent","stop"]))
            }, [
              (__props.multipleFiles || (!__props.multipleFiles && !fileList.value.length && !uploadedFileList.value.length))
                ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.mainIcon), { class: "w-12 h-12 text-gray-400 stroke-1 mb-3" })),
                      _createElementVNode("p", _hoisted_5, [
                        _hoisted_6,
                        _createTextVNode(" or drag and drop " + _toDisplayString(__props.dragAndDropText), 1)
                      ]),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(__props.acceptFilesText), 1)
                    ])
                  ])
                : _createCommentVNode("", true)
            ]),
            (__props.isPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedFileList.value, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "relative",
                        onMouseover: ($event: any) => (setXButton(file.name, true)),
                        onMouseleave: ($event: any) => (setXButton(file.name, false))
                      }, [
                        (file.mimetype === 'application/pdf')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["shadow-lg rounded-lg bg-gray-100 mb-2 flex justify-center items-center", hoverOnFile(file.name)])
                            }, _hoisted_12, 2))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              class: _normalizeClass(["object-cover shadow-lg rounded-lg mb-2", hoverOnFile(file.name)]),
                              height: __props.minHeight,
                              width: __props.minWidth,
                              src: file.url,
                              alt: "image"
                            }, null, 10, _hoisted_13)),
                        (isXVisible.value && hoveredFileName.value == file.name)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "absolute top-3 right-3 flex justify-center items-center bg-white w-10 h-10 rounded-lg",
                              onClick: _withModifiers(($event: any) => (removePreviewFile(index, file.name, true)), ["prevent"])
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "text-red-500 w-4 h-4" })
                            ], 8, _hoisted_14))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_10))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "relative max-w-fit",
                        onMouseover: ($event: any) => (setXButton(file.name, true)),
                        onMouseleave: ($event: any) => (setXButton(file.name, false))
                      }, [
                        (file.type === 'application/pdf')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["shadow-lg rounded-lg bg-gray-100 mb-2 flex justify-center items-center", hoverOnFile(file.name)])
                            }, _hoisted_17, 2))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              ref_for: true,
                              ref: "imagePreview",
                              class: _normalizeClass(["object-cover max-h-44 shadow-lg rounded-lg mb-2", hoverOnFile(file.name)]),
                              src: createPreview(file),
                              alt: "image"
                            }, null, 10, _hoisted_18)),
                        (isXVisible.value && hoveredFileName.value == file.name)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "absolute top-3 right-3 flex justify-center items-center bg-white w-10 h-10 rounded-lg",
                              onClick: _withModifiers(($event: any) => (removePreviewFile(index, file.name, false)), ["prevent"])
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "text-red-500 w-4 h-4" })
                            ], 8, _hoisted_19))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_15))
                    }), 128))
                  ], 512), [
                    [_vShow, uploadedFileList.value.length || fileList.value.length]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.defaultDocuments, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex flex-col text-sm"
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_unref(PaperClipIcon), { class: "w-5 h-5 mr-3 text-gray-400" }),
                            _createElementVNode("p", _hoisted_24, _toDisplayString(file.name), 1)
                          ]),
                          _createVNode(_unref(TrashIcon), {
                            class: "text-gray-400 w-5 h-5 cursor-pointer",
                            onClick: _withModifiers(($event: any) => (removeItemFromList(index)), ["prevent"])
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex flex-col text-sm"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_unref(PaperClipIcon), { class: "w-5 h-5 mr-3 text-gray-400" }),
                            _createElementVNode("p", _hoisted_27, _toDisplayString(file.name), 1)
                          ]),
                          _createVNode(_unref(TrashIcon), {
                            class: "text-gray-400 w-5 h-5 cursor-pointer",
                            onClick: _withModifiers(($event: any) => (removeItemFromList(index)), ["prevent"])
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ], 512), [
                    [_vShow, __props.defaultDocuments.length || fileList.value.length]
                  ])
                ]))
          ], 42, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _renderSlot(_ctx.$slots, "alternative", { upload: inputClick })
        ]))
  ], 2))
}
}

})